import { tailwindVariants } from '@air/utils-tailwind';

export const searchFieldChrome = tailwindVariants({
  base: 'relative flex w-full items-center gap-2 ui2026:gap-1 overflow-hidden whitespace-nowrap rounded-8 ui2026:rounded-full border border-gray-5 ui2026:border-gray-5 bg-gray-1 ui2026:bg-gray-1 text-left outline-none ring-2 ring-transparent transition-[background-color,box-shadow] ui2026:hover:bg-gray-1 hover:ring-black/[0.04] ui2026:hover:ring-transparent dark:hover:ring-white/[0.025] ui2026:dark:hover:ring-transparent',
  defaultVariants: {
    compact: false,
    padded: true,
    elevatedOnFocus: false,
  },
  variants: {
    compact: {
      false: 'h-10 ui2026:max-h-10',
      true: 'h-8 ui2026:max-h-8',
    },
    padded: {
      false: '',
      true: 'px-3 ui2026:px-1 ui2026:py-1',
    },
    elevatedOnFocus: {
      true: 'focus-within:overflow-visible ui2026:focus-within:border-gray-6 focus-within:shadow-search-command focus-within:ring-black/[0.04] ui2026:focus-within:ring-transparent dark:focus-within:ring-white/[0.025] ui2026:dark:focus-within:ring-transparent',
    },
  },
});

export const searchFieldIconSlot = tailwindVariants({
  base: 'flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden',
});

export const searchFieldText = tailwindVariants({
  base: 'min-w-0 flex-1 appearance-none border-none bg-transparent font-medium ui2026:font-normal text-16 text-gray-12 ui2026:text-14 [outline:none] placeholder:text-gray-9 ui2026:placeholder:text-gray-10 focus:shadow-none focus:ring-0 focus-visible:ring-0 focus:[outline:none] focus-visible:[outline:none]',
});

export const searchFieldClearReserve = tailwindVariants({
  base: 'pr-5',
});
